import React, { useContext, useEffect } from "react";
import Header_Jupiter from "./Header_Jupiter";
import Sidebar_Jupiter from "./Sidebar_Jupiter";
import { Outlet } from 'react-router-dom';
function DashboardMain_Jupiter(props) {


    return (
        <>
            <Header_Jupiter gloablfilter={props.gloablfilter} />
            <Sidebar_Jupiter />
            {props.children}
        </>
    );



}

export default DashboardMain_Jupiter;